var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{on:{"click":_vm.pick}},[_vm._t("trigger")],2),_c('input',{ref:"input",staticClass:"is-hidden",attrs:{"type":"file","accept":_vm.acceptAttr},on:{"input":_vm.onInput}})])}
var staticRenderFns = []

export { render, staticRenderFns }